// extracted by mini-css-extract-plugin
export default {"Wrapper":"checkBox_Wrapper__SYD5i","checkInput":"checkBox_checkInput__w+iwl","label":"checkBox_label__-zkKl"};